// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app"
import "firebase/compat/storage"
import "firebase/compat/firestore"
import 'firebase/compat/auth';
import { getDatabase } from 'firebase/database'; 
// import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAIV8sa5TdibCwCIaVrKCu5gZzDZB5lqqA",
  authDomain: "meteoyama-414fe.firebaseapp.com",
  projectId: "meteoyama-414fe",
  storageBucket: "meteoyama-414fe.appspot.com",
  messagingSenderId: "597150550852",
  appId: "1:597150550852:web:da8d55956524b0473aa511",
  measurementId: "G-KXD76PZ168",
  databaseURL: "https://meteoyama-414fe-default-rtdb.firebaseio.com/",
};

// Initialize Firebase
let app;
if (!firebase.apps.length) {
  app = firebase.initializeApp(firebaseConfig);
} else {
  app = firebase.app(); // Use the existing app
}

// Set up Firebase services
export const auth = app.auth();
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
export const storage = firebase.storage();
export const firestore = firebase.firestore();
export const provider = new firebase.auth.GoogleAuthProvider();
export const database = getDatabase(app);
export const analytics = getAnalytics(app);

export default app;